import { Component, Host, State, h } from '@stencil/core';

@Component({
  tag: 'lg-share',
  styleUrl: 'lg-share.scss',
})
export class LgShare {
  @State() showShareIcons = false;

  private shareUrl = document.querySelector('meta[property="og:url"]')?.getAttribute('content') || window.location.href;
  private shareTitle = document.querySelector('meta[property="og:title"]')?.getAttribute('content') || document.querySelector('title')?.textContent;
  private sharingLinks = [{
    name: 'mail',
    url: 'mailto:?subject=' + this.shareUrl + '&body='
  }, {
    name: 'facebook',
    url: 'https://www.facebook.com/sharer/sharer.php?u='
  }, {
    name: 'x',
    url: 'https://x.com/intent/tweet?url'
  }, {
    name: 'linkedin',
    url: 'https://www.linkedin.com/sharing/share-offsite/?url='
  }];

  toggleShareIcons() {
    if (navigator.share) {
      navigator.share({
        title: this.shareTitle,
        url: this.shareUrl
      })
    } else {
      this.showShareIcons = !this.showShareIcons;
    }
  }

  openShareLink(url: string) {
    window.open(url, '_blank');
  }

  render() {
    return (
      <Host>
        <nav class="share">
          <ul class="nav">
            <li class="nav-item d-flex flex-row-reverse justify-content-end align-items-center gap-md">
              <button class="nav-link p-0" type="button" onClick={()=>this.toggleShareIcons()}><lg-icon name="share"></lg-icon></button>
              <ul class={`share-icons nav flex-column align-items-center p-xs gap-2xs bg-white border border-primary ${this.showShareIcons ? 'd-flex' : 'd-none'}`}>
                {this.sharingLinks.map((link) => (
                  <li class="nav-item">
                    <button class="nav-link p-0" type="button" onClick={()=>this.openShareLink(link.url + this.shareUrl)}>
                      <lg-icon name={link.name}></lg-icon>
                    </button>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </nav>
      </Host>
    );
  }
}
